import type React from "react";

import { Stack, Typography } from "@mui/material";

interface LoginInfoContainerProps {
  children?: React.ReactNode;
  title: string;
}

export const LoginInfoContainer: React.FC<LoginInfoContainerProps> = ({ title, children }) => (
  <Stack spacing={1} textAlign="center">
    <Typography variant="h2">{title}</Typography>
    {children && <Typography>{children}</Typography>}
  </Stack>
);
